export class HistoryNavigator {
  static navigate;

  static init(navigator) {
    HistoryNavigator.navigate = navigator;
  }
}
